/* Standard Component Library Index */
import Add from "./core/add";
import Clock from "./core/clock";
import ConsoleLog from "./core/console_log";
import Filter from "./core/filter";
import Function from "./core/function";
import Join from "./core/join";
import Random from "./core/random";
import Subtract from "./core/subtract";
import TextColour from "./core/text_colour";
import Log from "./data/log"
import MidiIn from "./data/midi_in";
import WebRTC from "./data/web_rtc";
import Websocket from "./data/websocket";
import SerialIn from "./data/serial_in";
import SerialOut from "./data/serial_out";
import FIR from "./dsp/fir";
import IIR from "./dsp/iir";
import Oscillator from "./dsp/oscillator";
import LineChart from "./widgets/LineChart";
import Terminal from "./widgets/Terminal";

export default [
    Add,
    Clock,
    ConsoleLog,
    Filter,
    Function,
    Join,
    Random,
    Subtract,
    TextColour,
    Log,
    MidiIn,
    WebRTC,
    Websocket,
    SerialIn,
    SerialOut,
    FIR,
    IIR,
    Oscillator,
    LineChart,
    Terminal,
];
